import { render, staticRenderFns } from "./MiniProgramYanYunDongOrderYearlyPayment.vue?vue&type=template&id=2f0b08b3&scoped=true&"
import script from "./MiniProgramYanYunDongOrderYearlyPayment.vue?vue&type=script&lang=js&"
export * from "./MiniProgramYanYunDongOrderYearlyPayment.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramYanYunDongOrderYearlyPayment.vue?vue&type=style&index=0&id=2f0b08b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b08b3",
  null
  
)

export default component.exports